module.exports = __webpack_public_path__ + "static/media/11.101.534778ef.webp";